// apps/web/src/lib/kanban/unidade.ts — Fase 11 (WR-WEB-15).
// Rótulo das unidades de WIP, compartilhado pelo cabeçalho da raia e pelos avisos de liberação.

const ROTULOS: Record<string, string> = {
  CARTOES: 'cartões',
  PECAS: 'peças',
  KG: 'kg',
  M2: 'm²',
  GANCHEIRAS: 'gancheiras',
};

/** `unidade` vem de `detalhe: Record<string, unknown>` nos avisos, então aceita qualquer valor. */
export function rotuloUnidade(unidade: unknown): string {
  if (typeof unidade !== 'string') return '';
  return ROTULOS[unidade] ?? unidade.toLowerCase();
}
